/* eslint-disable max-len */
import React, {
  useEffect, useState, ChangeEvent, MouseEvent, KeyboardEvent,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, IconButton, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import posthog from 'posthog-js';
import { ellipsis } from 'polished';

import Color from '@tool/color';
import moHeader, {
  changeValue, changeJobname,
} from './store/index';
import {
  SearchIcon, IconX21, IconX22, IconX23, IconX24, VPlay,
} from '@styled/icon';
import AdSlick from './ad-slick';
import moUser from '@store/user';
import moSkin from '@store/skin';
import moHome, { setUrl, toggleOpen } from '@store/home';

interface IProps {}
interface IState {}

const DInput = styled(InputBase)(() => ({
  width: '390px',
  height: '36px',
  padding: '0 0 0 10px',
  borderBottom: 'none',
  borderRadius: '5px',
  border: `1px solid ${Color.ec}`,
  backgroundColor: Color.fff,

  '& input': {
    padding: 0,
    fontSize: '12px',
    fontWeight: 500,
    color: Color.c55,
  },
  '& input::placeholder': {
    opacity: 1,
    color: Color.cf,
  },
}));

const DIconButton = styled(IconButton)(() => ({
  padding: '6px 10px',
  borderRadius: 0,
  '&:hover': { backgroundColor: Color.blackColor(0) },
}));

const DButton = styled(Button)(() => ({
  height: '36px',
  padding: '0 8px',
  marginLeft: '10px',
  marginBottom: '5px',
  fontSize: '12px',
  fontWeight: 500,
  borderRadius: '5px',
  color: Color.c55,
  backgroundColor: Color.primaryColor(0.1),

  '&:hover': { backgroundColor: Color.primaryColor(0.1) },
}));

{/** 关于我们 */}
const PopUs = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { popMarket, jobname, subJobList } = moHeader;
  const { modules, partner } = moSkin;
  const list = [
    {
      imageUrl: 'https://file.smartsalary.cn/web-img%402.0/home/nav003.png',
      toUrl: '/market/insight',
    },
  ];

  useEffect(() => {
    return () => {};
  }, []);

  const onQuery = (ev?: MouseEvent) => {
    ev?.stopPropagation();
    posthog.capture('导航市场薪酬查询人数', {});
    if (isEmpty(jobname)) {
      let newJob = '';
      if (!isEmpty(subJobList)) newJob = subJobList[0].job_name || '';

      if (!newJob) {
        changeJobname('');
        localStorage.setItem('jobname', '');
        window.location.href = '/market/marketpay';
      } else {
        changeJobname('');
        localStorage.setItem('jobname', newJob);
        window.location.href = '/market/result';
      }
    } else {
      changeJobname('');
      localStorage.setItem('jobname', jobname);
      window.location.href = '/market/result';
    }
  };

  const onPress = (ev: KeyboardEvent) => {
    ev.stopPropagation();
    posthog.capture('导航市场薪酬查询人数', {});
    if (ev.key === 'Enter') onQuery();
  };

  // 悦世界
  const onJumpOmnisight = () => {
    // posthog.capture('顶部导航栏跳转-悦世界', {});
    window.location.href = '/home/HROmnisigth';
  };

  // 调研报告
  const onJumpWtw = () => {
    // posthog.capture('顶部导航栏跳转-调研报告', {});
    window.location.href = '/home/wtw';
  };

  // 客户案例
  const onJumpSample = () => {
    // posthog.capture('顶部导航栏跳转-客户案例', {});
    window.location.href = '/home/cooperation';
  };

  // 新闻中心
  const onJumpNews = () => {
    // posthog.capture('顶部导航栏跳转-新闻中心', {});
    window.location.href = '/home/news';
  };

  // 企业客户
  const onJumpCustomers = () => {
    // posthog.capture('顶部导航栏跳转-企业客户', {});
    window.location.href = '/home/customers';
  };

  // 成为合作伙伴
  const onJumpCooperation = () => {
    // posthog.capture('顶部导航栏跳转-成为合作伙伴', {});
    window.location.href = '/home/cooperation';
  };

  // 关于我们
  const onJumpUs = () => {
    // posthog.capture('顶部导航栏跳转-关于我们', {});
    window.location.href = '/home/team';
  };

  // 客户对薪智评价
  const onCustomers = () => {
    // posthog.capture('顶部导航栏跳转-客户对薪智评价', {});
    window.location.href = '/home/customers';
  };

  // 成为我们的合作伙伴
  const onCooperation = () => {
    // posthog.capture('顶部导航栏跳转-成为我们的合作伙伴', {});
    window.location.href = '/home/cooperation';
  };

  // 点击热门职位
  const onHotJob = (value: string) => {
    // posthog.capture(`顶部导航栏跳转-${value}`, {});
    changeJobname('');
    localStorage.setItem('jobname', value);
    window.location.href = '/market/result';
  };

  // 播放视频
  const onPlay = () => {
    changeValue('popUs', false);
    setUrl('https://file.smartsalary.cn/v2-video/%E6%98%93%E8%B7%AF%E8%81%8C%E5%9C%BA%E7%94%A8%E8%96%AA%E8%AF%B4-%E7%AC%AC%E4%B8%80%E6%9C%9F03_%E7%AC%AC%E4%B8%89%E8%8A%82.mp4');
    toggleOpen(true);
  };

  return (
    <section aria-hidden="true" className="header-pop_100"
      onMouseEnter={() => changeValue('popUs', true)}
      onMouseLeave={() => changeValue('popUs', false)}>
      <section className="pop-1010">
        <section className="pop-box_100">
          <i className="tri-10 tri-13" />
          <section className="box-10">
            <section className="search-11">
              <DInput value={jobname}
                endAdornment={(
                  <DIconButton onClick={onQuery}>
                    <SearchIcon color={Color.primary} />
                  </DIconButton>
                )}
                onChange={(ev: ChangeEvent<HTMLInputElement>) => changeJobname(ev.target.value)}
                onKeyPress={onPress}
                placeholder="请输入职位名称搜索" />
              <section className="search-101">
                {!isEmpty(subJobList) ? (
                  <DButton onClick={() => onHotJob(subJobList[0]?.job_name)}>
                    {subJobList[0]?.job_name}
                  </DButton>
                ) : null}
                <DButton onClick={onCustomers}>客户对薪智评价</DButton>
                <DButton onClick={onCooperation}>成为我们的合作伙伴</DButton>
              </section>
            </section>
            <section className="card-11">
              <section className="card-101" aria-hidden="true" onClick={onJumpOmnisight}
                data-attr="ph-capture" data-custom-id="us01">
                <p className="line-101">
                  <IconX21 />
                  <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>悦仕界</b>
                </p>
                <span style={{ ...ellipsis('100%', 2) }}>
                薪智 & 苇莱韬悦 大数据平台
                </span>
              </section>
              <section className="card-101" aria-hidden="true" onClick={onJumpWtw}
                data-attr="ph-capture" data-custom-id="us02">
                <p className="line-101">
                  <IconX21 />
                  <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>调研报告</b>
                </p>
                <span style={{ ...ellipsis('100%', 2) }}>
                苇莱韬悦：「销售激励报告」、「人员配置报告」
                </span>
              </section>
              {/* <section className="card-101" aria-hidden="true" onClick={onJumpSample}>
                <p className="line-101">
                  <IconX22 /><b>客户案例</b>
                </p>
                <span style={{ ...ellipsis('100%', 2) }}>
                做出更合理的职位薪酬规划 让员工保存内外竞争力
                </span>
              </section> */}
              <section className="card-101" aria-hidden="true" onClick={onJumpNews}
                data-attr="ph-capture" data-custom-id="us03">
                <p className="line-101">
                  <IconX21 />
                  <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>新闻中心</b>
                </p>
                <span style={{ ...ellipsis('100%', 2) }}>了解薪智最新动态，了解市场薪酬动态</span>
              </section>
              <section className="card-101" aria-hidden="true" onClick={onJumpCustomers}
                data-attr="ph-capture" data-custom-id="us04">
                <p className="line-101">
                  <IconX22 />
                  <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>企业客户</b>
                </p>
                <span style={{ ...ellipsis('100%', 2) }}>我们的用户遍布 互联网、 通讯、 金融、 咨询、 零售快消、 政府、 物流、 地产等众多领域</span>
              </section>
              <section className="card-101" aria-hidden="true" onClick={onJumpCooperation}
                data-attr="ph-capture" data-custom-id="us05">
                <p className="line-101">
                  <IconX23 />
                  <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>成为合作伙伴</b>
                </p>
                <span style={{ ...ellipsis('100%', 2) }}>合作共赢薪智开放平台。欢迎成为我们的合作伙伴</span>
              </section>
              <section className="card-101" aria-hidden="true" onClick={onJumpUs}
                data-attr="ph-capture" data-custom-id="us06">
                <p className="line-101">
                  <IconX24 />
                  <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>关于我们</b>
                </p>
                <span style={{ ...ellipsis('100%', 2) }}>我们的愿景、团队、历程</span>
              </section>
            </section>
          </section>

          <section className="box-20">
            <section className="box-21">
              <AdSlick list={list} />
            </section>
            <section className="box-22">
              <p className="title-1122">薪酬水平是如何变化的？</p>
              <p className="img-11220" aria-hidden="true" onClick={onPlay}>
                <img src="https://file.smartsalary.cn/web-img%402.0/home/v-about-us.png"
                  alt="cover" className="img-1122" />
                <VPlay />
              </p>
            </section>
          </section>

        </section>
      </section>
    </section>
  );
};

export default observer(PopUs);
